// extracted by mini-css-extract-plugin
export default {"page":"ComparisonPage_page__tF2bl"};